// @flow
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { CSSTransition } from 'react-transition-group';
import { useTranslation } from 'react-i18next';
import { useParams, useHistory } from 'react-router-dom';
import ProcessingLoader from 'components/shared/ProcessingLoader/ProcessingLoader';

import ErrorPopUp from 'components/shared/ErrorPopUp/ErrorPopUp';

import userActions from 'actions/user';
import Supporters from 'components/shared/Supporters';
import { sendAnalyticsPath } from 'utils/analyticsWrapper';
import PublicGoals from './Goals';
import AccountInformation from './AccountInformation';

const UserProfilePage = (props: Props) => {
  const { t } = useTranslation();

  const { userName } = useParams();

  const browserHistory = useHistory();

  const [errorPopUp, setErrorPopUp]: [any,
    ((any => any) | any) => void] = useState({ show: false });

  const {
    information, isProcessing, goals, investors, error,
  } = props;

  const fetchUser = () => {
    sendAnalyticsPath('user/username');

    props.getUser(userName)
      .catch(() => browserHistory.push('/notfound'));
  };

  useEffect(() => {
    if (information) {
      return;
    }
    fetchUser();
  }, []);

  if (isProcessing) {
    return <ProcessingLoader show />;
  }

  return (
    <>
      <CSSTransition
        in={!isProcessing}
        timeout={300}
        classNames="page"
        unmountOnExit
      >
        <div>
          <AccountInformation info={information} />

          <PublicGoals goals={goals} owner={information} />

          <Supporters title={t('supporters_text_title')} data={investors} />
        </div>

      </CSSTransition>

      <ErrorPopUp
        show={(errorPopUp.show)}
        onBack={() => {
          setErrorPopUp({ ...errorPopUp, show: false });
          fetchUser();
        }}
      />
    </>
  );
};

// Map Props
const mapStateToProps = (state) => ({
  isProcessing: state.publicProfile.isProcessing,
  information: state.publicProfile.information,
  goals: state.publicProfile.goals,
  investors: state.publicProfile.investors,
  error: state.publicProfile.error,
});

// Map Dispatch
const mapDispatchToProps = (dispatch) => ({
  getUser:
    (userName: string) => dispatch(userActions.getPublicInformation(userName)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UserProfilePage);
